import React, { useState, useRef, useEffect } from "react";
import Menu from "./Menu/Menu";
import Burger from "./Menu/Burger";
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./Menu/global";
import { theme } from ".//Menu/theme";
import { Link  } from 'react-router-dom'
import { Helmet } from "react-helmet";

import {
  faInstagram,
  faFacebookF,
  faLinkedinIn,

} from "@fortawesome/free-brands-svg-icons";
import Fade from "react-reveal/Fade";

import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Privacy(historyurl) {
  const [open, setOpen] = useState(false);
  const history = useHistory();

  const [sticky, setSticky] = useState({ isSticky: false, offset: 0 });
  const headerRef = useRef(null);

  // handle scroll event
  const handleScroll = (elTopOffset, elHeight) => {
    if (window.pageYOffset > elTopOffset + elHeight) {
      setSticky({ isSticky: true, offset: elHeight });
    } else {
      setSticky({ isSticky: false, offset: 0 });
    }
  };
 // router
 function handleClick(e, path) {
  e.preventDefault();
  window.open(path, '_blank') 
}
  // add/remove scroll event listener
  useEffect(() => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
    var header = headerRef.current.getBoundingClientRect();
    const handleScrollEvent = () => {
      handleScroll(header.top, header.height);
    };

    window.addEventListener("scroll", handleScrollEvent);

    return () => {
      window.removeEventListener("scroll", handleScrollEvent);
    };
  }, []);
  return (
    <div>
    <Helmet>
              <meta charSet="utf-8" />
              <title>Nos-Wazeefa privacy</title>
              <link
                rel="canonical"
                href="http://noswazeefa.net/privacy"
              />
          </Helmet>
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyles />
    <div>
      <div className='english privacy'>
      <div id="menu_mobile">
            <Burger open={open} setOpen={setOpen} />
            <Menu open={open} setOpen={setOpen} />
          </div>
        <header id="Home">
          <nav
            id="sticky-header"
            className='sticky privacy'
            ref={headerRef}
          >
            <div>
              <div className="logo">
                <Link  rel="canonical"to="/">


                  <img src={require("../assets/images/logo.png")} alt="logo" />


                </Link>
              </div>
              <div className="list">
                <ul>
                  <li>
                    <a
                      onClick={() => history.push('/#Home')}

                    >
                      Home
                      </a>
                  </li>
                  <li>
                    <a

                      onClick={() => history.push('/#Features')}

                    >
                      Download the App
                      </a>
                  </li>

                  <li>
                    <a
                      onClick={() => history.push('/#Company')}

                    >
                      Company Website
                      </a>
                  </li>
                  <li>
                    <a


                    >
                      Privacy&Policy
                      </a>
                  </li>
                  <li>
                    <a
                      onClick={() => history.push('/#Contact')}

                    >
                      Contact
                      </a>
                  </li>
                  <li className="tomainPage">
                    <Link  rel="canonical"to="/ar" className="ar" >
                      العربيه
                      </Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>

    
          <div className="privacy">

         <section className="hdr">

           <h2>Privacy & Policy</h2>
         </section>
         <main>
         <section >

           <ul>

             <li><strong>Nos Wazeefa </strong>is committed to protecting privacy for all users: our main target is to 
               provide you a safe electronic experience and 
               ensure privacy of any given information for the following purposes only.</li>
               <li><strong>Nos Wazeefa </strong>is <span><Link  rel="canonical"to='/'>Website</Link></span>||<span><a href="https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en">App</a> </span>, 
               will ask employers and job seekers for some information related to required 
                 job| employee to have a better searching process.</li>
           </ul>
         </section>
         <section>
<h4>Registration</h4>
           <ul>




             <li>
             To enjoy a full-service while using “Nos Wazeefa” Website\ App you must register or create an account.             </li>
             <li>
               
 To register, employers and job seekers will be asked to provide their contacts and further information about them.
               </li>
               <li>
              
 <strong>Nos Wazeefa </strong> is the only owner of the collected information on the registration pages, and will not disclose the given information to any other party than <strong>NAT</strong> (the owner of “Nos Wazeefa"). Your contact information such as your name and email address may be used in informing you of any features|services offered by our <span><Link  rel="canonical"to='/'>Website</Link></span>||<span><a href="https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en">App</a> </span> that may be useful.  
               </li>
               <li>
               Our goal is to provide our users with a great service that will positively affect them every time they access “Nos Wazeefa”   <span><Link  rel="canonical"to='/'>Website</Link></span>||<span><a href="https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en">App</a> </span>, That is why we invite you to take a look on the required jobs and other.

               </li>
           </ul>
           </section>
           <section> 
         <h4>CVs</h4>
    <p>    Job seekers can publish their CVs in the database by two ways:</p>
    <ul>

      <li>      Job seekers can fill in the fields left for their personal information, education, experience and more. They can also upload their CV directly to the  <span><Link  rel="canonical"to='/'>Website</Link></span>||<span>
        <a href="https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en">App</a> </span> </li>
      <li>  <strong>Nos Wazeefa </strong> is not responsible for the privacy of copies which are taken by another companies for recruitment. You can make changes or delete your CV from our database whenever you want.</li> 


    </ul>

    </section>   
    <section>
    <h4>Job Announcements</h4>
<ul>

  <li>Companies have to provide detailed contact information and all about requirements about the needed position. All details about the announced position will be shown to any job seeker registered in our database Companies will hide their name during the announcement of a hiring position for their privacy policy. 
    You can change|edit| delete any information you have entered whenever you want.</li>
</ul>



    </section>

<section>
<h4>Profile</h4>
<ul>

  <li>Each job seeker or employer registered in Nos Wazeefa <span><Link  rel="canonical"to='/'>Website</Link></span>||<span>
        <a href="https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en">App</a> </span>will has its own profile to manage job| employees searching process.</li>
</ul>
<p>**Incase our privacy policy has been changed; we will keep it updated to ensure that our users enjoying our <span><Link  rel="canonical"to='/'>Website</Link></span>||<span><a href="https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en">App</a> </span></p>
</section>



         </main>
         <footer>
            <div>
            <Fade bottom>
              <h4>
                Download our App Today & <br /> Experience Endless Possibilities
              </h4>
              </Fade>
              <div className="buttons apple_google">
                <button
                  onClick={(e) =>
                    handleClick(
                      e,
                      "https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en"
                    )
                  }
                >
            
                                    <img src={require("../assets/images/google.png")} alt=''/>


                </button>
                <button
                  onClick={(e) =>
                    handleClick(
                      e,
                      "https://apps.apple.com/gb/app/noswazeefa/id1491881612?l=nb"
                    )
                  }
                >

                  <img src={require("../assets/images/apple.png")} alt=''/>

                </button>
              </div>
            </div>

            <div className="bot_page">
              <p>
                © copyright 2020 | All right reserved.Developed by{" "}
                <span>
                  <a href="https://natsaudi.net/" target="_blank">NAT</a>
                </span>{" "}
                | <Link  rel="canonical"to="/privacy">Privacy&Policy</Link>
              </p>

              <div className="social_icons">
                <a href="https://www.instagram.com/noswazeefa/" target="_blank">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a href="https://www.facebook.com/noswazeefasa/" target="_blank">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a href="https://www.linkedin.com/company/noswazeefa/?viewAsMember=true" target="_blank">
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
              </div>
            </div>
          </footer>

      </div>
    </div>
  </div>
  </>
    </ThemeProvider>


</div>
  )
}
export default Privacy; 